import { CircularProgress } from "@mui/material"
import { t } from "i18next"

import { BRAND_NAME, LOGO_SRC } from "@/utils/brand"

import { styles } from "./styles"

export function DeploymentPage() {
    return (
        <div style={styles.page}>
            <div style={styles.card}>
                <img src={LOGO_SRC} alt={BRAND_NAME} style={styles.logo} />
                <h2 style={styles.heading}>{t("Update in progress")}</h2>
                <p style={styles.paragraph}>{t("We are deploying a new version. Please wait a moment.")}</p>
                <p style={styles.paragraph}>
                    {t("This page will refresh automatically when the application is ready.")}
                </p>
                <div style={styles.spinner}>
                    <CircularProgress color="secondary" thickness={2.5} size={70} />
                </div>
            </div>
        </div>
    )
}

export default DeploymentPage
